export const RULES_FILE_LINK =
  'https://front.ffins.kz/storage/1153/fa3aa7f7-a80e-48f8-990f-e7fc5bb1c2d2.pdf?_gl=1*1rqgdbt*_gcl_au*ODYyNjg3Mjk5LjE3Njk2Nzc3ODM.';
export const PERSONAL_DATA_LINK =
  'https://ffins.kz/ru/pages/polodgenie-ob-obrabotke-personalnykh-dannykh';

export const BaseMedicalInsuranceConfig = {
  RULES_FILE_LINK,
  PERSONAL_DATA_LINK,
};
